<template>
  <v-form ref="form">
    <v-row class="containerAddCost">
      <v-col cols="12">
        <h3 class="black--text mb-4">Adicionar Cotação</h3>
      </v-col>
      <v-row>
        <v-col class="pr-sm-2">
          <BaseFormSelect
            id-element="insuranceCompanyQuotation"
            placeholder="Escolher"
            label-text="Seguradora"
            v-model="newCost.seguradora"
            :items="insuranceCompanyOptions"
            item-text="nome"
            item-value="codigo"
            required
            :rules="[requiredInput]"
            :return-object="true"
          />
        </v-col>
        <v-col class="pr-0 pr-sm-2">
          <BaseMoney
            id-element="insuredAreaQuotation"
            placeholder="0,00"
            label-text="Área Segurada (ha)"
            v-model="newCost.area_segurada"
            required
            :rules="[requiredInput]"
            :money="typeDecimal"
            :errorMessages="areaSeguradaErrorMessages"
            :v-on:change="validateAreaSegurada()"
          />
        </v-col>
        <v-col class="pr-0 pr-sm-2">
          <BaseMoney
            id-element="plantValueQuotation"
            placeholder="0,00"
            label-text="Valor da Planta"
            v-model="newCost.valor_planta"
            required
            :rules="[requiredInput]"
            :disabled="false"
            :errorMessages="valorPlantaErrorMessages"
            :v-on:change="validateValorPlanta()"
          />
        </v-col>
      </v-row>
      <v-row class="mb-2 mt-1">
        <v-col cols="12">
          <p class="primary--text form__title">
            Coberturas
          </p>
        </v-col>
        <v-col class="pr-0 pr-sm-2">
          <BaseFormSelect
            v-model="selectedCoverage"
            :items="coverageOptions"
            placeholder="Escolher"
            label-text="Cobertura básica"
            required
            item-text="nome"
            item-value="id"
            :return-object="true"
            @change="selectedCoverageValor()"
            :rules="[requiredInput]"
          />
        </v-col>
        <v-col class="pr-0 pr-sm-2">
          <v-col cols="auto" class="colPos">
            <v-tooltip bottom content-class="tooltip-label-form">
              <template v-slot:activator="{ on }">
                <v-icon
                  color="secondary"
                  size="12"
                  v-on="on"
                  class="iconTooltipLmi"
                >
                  fa-info-circle
                </v-icon>
              </template>
              <v-row>
                <v-col cols="12" class="px-4 py-3">
                  <p class="white--text tooltip-label-text mb-0">
                    Limite Máximo Indenizável
                  </p>
                </v-col>
              </v-row>
            </v-tooltip>
            <BaseMoney
              id-element="insuredValueQuotation"
              placeholder="0,00"
              label-text="Valor Cobertura básica"
              v-model="valorCoverageSelected"
              required
              :rules="[requiredInput, aboveZero]"
              :disabled="false"
              :errorMessages="valorCoberturaErrorMessages"
              :v-on:change="validateCobertura()"
            />
          </v-col>
        </v-col>
        <v-col class="pr-0 pr-sm-2">
          <BaseMoney
            id-element="insuredValueQuotation"
            placeholder="0,00"
            label-text="Perda Produção Futura"
            v-model="newCost.perda_producao_futura"
            :disabled="false"
          />
        </v-col>
        <v-col class="pr-0 pr-sm-2">
          <BaseMoney
            id-element="insuredValueQuotation"
            placeholder="0,00"
            label-text="Tratamento Fitossanitário"
            v-model="newCost.tratamento_fitossanitario"
            :disabled="false"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pr-0 pr-sm-2">
          <v-col cols="auto" class="colPos">
            <v-tooltip bottom content-class="tooltip-label-form">
              <template v-slot:activator="{ on }">
                <v-icon
                  color="secondary"
                  size="12"
                  v-on="on"
                  class="iconTooltipPos"
                >
                  fa-info-circle
                </v-icon>
              </template>
              <v-row>
                <v-col cols="12" class="px-4 py-3">
                  <p class="white--text tooltip-label-text mb-0">
                    Participação Obrigatória do Segurado, valor ou percentual de
                    responsabilidade do segurado nos prejuízos indenizáveis
                    decorrentes de sinistros cobertos.
                  </p>
                </v-col>
              </v-row>
            </v-tooltip>
            <BaseFormSelect
              id-element="paymentFormQuotation"
              placeholder="Escolher"
              label-text="POS"
              v-model="newCost.tipo_pos"
              :items="paymentConditions"
              item-text="nome"
              item-value="id"
              required
              :rules="[requiredInput]"
              :return-object="true"
            />
          </v-col>
        </v-col>
        <v-col class="pr-0 pr-sm-2">
          <BaseMoney
            id-element="totalQuotation"
            placeholder="0,00"
            label-text="Prêmio Total"
            v-model="newCost.premio_total"
            required
            :rules="[requiredInput]"
            :disabled="false"
            :errorMessages="premioTotalErrorMessages"
            :v-on:change="validatePremioTotal()"
          />
        </v-col>
        <v-col class="pr-0 pr-sm-2">
          <BaseMoney
            id-element="comissaoQuotation"
            label-text="Comissão(%)"
            v-model="newCost.comissao"
            required
            :rules="[requiredInput]"
            :disabled="false"
            :money="typeDecimal"
          />
        </v-col>
      </v-row>
      <v-row class="mb-8">
        <v-col class="pr-0 pr-sm-2">
          <BaseMoney
            id-element="federalSubventionQuotation"
            placeholder="0,00"
            label-text="Subvenção Federal"
            v-model="newCost.subvencao_federal"
            :disabled="false"
          />
        </v-col>
        <v-col class="pr-0 pr-sm-2">
          <BaseMoney
            id-element="stateSubventionQuotation"
            placeholder="0,00"
            label-text="Subvenção Estadual"
            v-model="newCost.subvencao_estadual"
            :disabled="false"
          />
        </v-col>
        <v-col class="pr-0 pr-sm-2">
          <BaseMoney
            id-element="totalQuotation"
            label-text="Prêmio do Segurado"
            v-model="newCost.premio_segurado"
            required
            :disabled="false"
            :readonly="true"
          />
        </v-col>
        <v-col class="pr-0 pr-sm-2">
          <BaseMoney
            id-element="totalQuotation"
            label-text="Investimento R$/ha"
            v-model="newCost.investimento"
            required
            :disabled="false"
            :readonly="true"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" class="pr-sm-5">
          <BaseButton
            v-html="saveText"
            class="white--text secondary"
            width="100%"
            @click="adicionar()"
          />
        </v-col>
        <v-col cols="3" class="pr-sm-5">
          <BaseButton
            ref="formFocus"
            v-html="'Cancelar'"
            class="white--text secondary"
            width="100%"
            @click="cancelar()"
          />
        </v-col>
      </v-row>
    </v-row>
  </v-form>
</template>
<script>
// Objeto criado para simular valores vindos da API
const TIPO_POS = [
  {
    id: "normal",
    nome: "Normal"
  },
  {
    id: "reduzida",
    nome: "Reduzida"
  }
];

const TIPO_COBERTURA = [
  {
    id: "granizo",
    nome: "Granizo"
  },
  {
    id: "granizo_geada",
    nome: "Granizo e Geada"
  }
];

const defaultCost = {
  id: null,
  seguradora: null,
  area_segurada: 0,
  valor_planta: 0,
  granizo: 0,
  granizo_geada: 0,
  perda_producao_futura: 0,
  tratamento_fitossanitario: 0,
  tipo_pos: TIPO_POS[0], // Receberá valores de um Enum vindo da API.
  premio_total: 0,
  subvencao_federal: 0,
  subvencao_estadual: 0,
  premio_segurado: 0,
  investimento: 0,
  visible: true,
  comissao: 10
};
const money = {
  decimal: ",",
  thousands: ".",
  prefix: "",
  suffix: "",
  precision: 2,
  masked: false /* doesn't work with directive */
};

import { requiredInput, maxLengthNumber } from "@/utils/rules.js";
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import CompanyMixin from "@/mixins/CompanyMixin";
import _ from "lodash";
import BaseMoney from "../../../components/base/BaseMoney.vue";

export default {
  components: { BaseMoney },
  data: () => ({
    formValid: true,
    loading: false,
    requiredInput,
    timeout: null,
    maxLengthNumber,
    coverageOptions: TIPO_COBERTURA,
    selectedCoverage: null,
    valorCoverageSelected: 0,
    // novos campos agro
    quotationCostsCafezal: [],
    paymentConditions: TIPO_POS,
    // listInsuranceCompany: null, //ver como pegar a lista de seguradoras
    // listInsuranceCompanyQuotation: [],
    newCost: defaultCost,
    typeDecimal: money,
    comissao: 8,
    areaSeguradaErrorMessages: [],
    valorPlantaErrorMessages: [],
    granizoGeadaErrorMessages: [],
    perdaProducaoErrorMessages: [],
    tratamentoErrorMessages: [],
    premioTotalErrorMessages: [],
    valorCoberturaErrorMessages: []
  }),
  created() {
    if (
      this.itemIndex < 0 ||
      this.itemIndex >= this.formCosts.quotationCostsCafezal.length
    ) {
      this.newCost = _.cloneDeep(defaultCost);
    } else {
      this.newCost = _.cloneDeep(
        this.formCosts.quotationCostsCafezal[this.itemIndex]
      );
    }
    this.fetchOptions();
    this.selectCoverage();
  },
  computed: {
    ...mapState(["loadingStatus"]),
    ...mapState("quotation", [
      "insuredByNameOrCPFCNPJ",
      "insuranceCompanyOptions"
    ]),
    formCosts: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    saveText() {
      return this.itemIndex == -1 ? "Adicionar" : "Salvar";
    }
  },
  mixins: [LoadingRequest, CompanyMixin],
  methods: {
    ...mapActions("quotation", [
      "requestInsuredByNameOrCPFCNPJ",
      "fetchInsuranceCompany"
    ]),
    ...mapActions(["hasLoading", "showAlertNotification"]),
    selectCoverage() {
      if (this.newCost.granizo > 0 && this.coverageOptions[0]) {
        this.valorCoverageSelected = this.newCost.granizo;
        return (this.selectedCoverage = this.coverageOptions[0]);
      } else if (this.newCost.granizo_geada > 0 && this.coverageOptions[1]) {
        this.valorCoverageSelected = this.newCost.granizo_geada;
        return (this.selectedCoverage = this.coverageOptions[1]);
      }
    },
    validateCoverage() {
      if (this.selectedCoverage.id == null) {
        this.$refs.coverageInput.validate();
      }
    },
    selectedCoverageValor() {
      if (this.selectedCoverage?.id == this.coverageOptions[0].id) {
        this.newCost.granizo_geada = 0;
        this.newCost.granizo = this.valorCoverageSelected;
      } else if (this.selectedCoverage?.id == this.coverageOptions[1].id) {
        this.newCost.granizo_geada = this.valorCoverageSelected;
        this.newCost.granizo = 0;
      }
    },
    async fetchOptions() {
      let payload = {
        somenteAtivos: true,
        modalidade: "cafezal"
      };
      await this.withLoading(
        Promise.all([this.fetchInsuranceCompany(payload)])
      );
    },
    // focusForm() {
    //   setTimeout(() => {
    //     this.$refs.formFocus.$el.focus();
    //   }, 200);
    // },
    aboveZero(value) {
      return value > 0 || "O valor deve ser maior do que 0.";
    },
    adicionar() {
      if (!this.validar()) {
        this.validateInputBaseMoney();
        this.showAlertNotification({
          message: "Todos os campos devem ser preenchidos",
          type: "error"
        });
        return;
      }
      if (this.itemIndex == -1) {
        this.formCosts.quotationCostsCafezal.push(this.newCost);
      } else {
        if (this.itemIndex < this.formCosts.quotationCostsCafezal.length) {
          this.formCosts.quotationCostsCafezal[this.itemIndex] = this.newCost;
          this.formCosts.quotationCostsCafezal = _.cloneDeep(
            this.formCosts.quotationCostsCafezal
          );
        }
      }

      this.$emit("update:enableCost", false);
    },
    cancelar() {
      this.$emit("cancel");
    },
    CalcularPrecoSegurado() {
      let priceTotal = this.newCost.premio_total ?? 0;
      let subvencaoEstadual = this.newCost.subvencao_estadual ?? 0;
      let subvencaoFederal = this.newCost.subvencao_federal ?? 0;

      let price = priceTotal - subvencaoEstadual - subvencaoFederal;

      if (price > 0) {
        this.newCost.premio_segurado = price.toFixed(2);
      }
    },
    CalcularInvestimento() {
      let areaSegurada = this.newCost.area_segurada ?? 0;
      let premioSegurado = this.newCost.premio_segurado ?? 0;

      let price = premioSegurado / areaSegurada;

      if (price > 0) {
        this.newCost.investimento = price.toFixed(2);
      }
    },
    validateInputBaseMoney() {
      if (
        !this.newCost.area_segurada > 0 &&
        this.areaSeguradaErrorMessages.length == 0
      ) {
        this.areaSeguradaErrorMessages.push("Este campo é obrigatório");
      }

      if (
        !this.newCost.valor_planta > 0 &&
        this.valorPlantaErrorMessages.length == 0
      ) {
        this.valorPlantaErrorMessages.push("Este campo é obrigatório");
      }

      if (
        (!this.newCost.granizo_geada > 0 || !this.newCost.granizo > 0) &&
        this.granizoGeadaErrorMessages.length == 0
      ) {
        this.granizoGeadaErrorMessages.push("Este campo é obrigatório");
      }

      if (
        !this.newCost.premio_total > 0 &&
        this.premioTotalErrorMessages.length == 0
      ) {
        this.premioTotalErrorMessages.push("Este campo é obrigatório");
      }

      if (
        !this.valorCoverageSelected > 0 &&
        this.valorCoberturaErrorMessages.length == 0
      ) {
        this.valorCoberturaErrorMessages.push("Este campo é obrigatório");
      }
    },
    validateCobertura() {
      if (
        this.valorCoverageSelected > 0 &&
        this.valorCoberturaErrorMessages.length != 0
      ) {
        this.valorCoberturaErrorMessages = [];
      }
    },
    validateAreaSegurada() {
      if (
        this.newCost.area_segurada > 0 &&
        this.areaSeguradaErrorMessages.length != 0
      ) {
        this.areaSeguradaErrorMessages = [];
      }
    },
    validateValorPlanta() {
      if (
        this.newCost.valor_planta > 0 &&
        this.valorPlantaErrorMessages.length != 0
      ) {
        this.valorPlantaErrorMessages = [];
      }
    },
    validateGranizoGeada() {
      if (
        (this.newCost.granizo > 0 || this.newCost.granizo_geada > 0) &&
        this.granizoGeadaErrorMessages.length != 0
      ) {
        this.granizoGeadaErrorMessages = [];
      }
    },
    validatePremioTotal() {
      if (
        this.newCost.premio_total > 0 &&
        this.premioTotalErrorMessages.length != 0
      ) {
        this.premioTotalErrorMessages = [];
      }
    },
    validar() {
      return (
        this.$refs.form.validate() &&
        this.newCost.area_segurada > 0 &&
        this.newCost.valor_planta > 0 &&
        (this.newCost.granizo_geada > 0 || this.newCost.granizo > 0) &&
        this.newCost.premio_total > 0 &&
        this.newCost.premio_segurado > 0 &&
        this.newCost.investimento > 0 &&
        this.newCost.comissao >= 0
      );
    }
  },
  watch: {
    "newCost.area_segurada": function(newValue, oldValue) {
      if (
        !newValue ||
        newValue == oldValue ||
        newValue?.area_segurada == oldValue?.area_segurada
      )
        return this.CalcularInvestimento();
    },
    "newCost.premio_segurado": function(newValue, oldValue) {
      if (
        !newValue ||
        newValue == oldValue ||
        newValue?.premio_segurado == oldValue?.premio_segurado
      )
        return this.CalcularInvestimento();
    },
    "newCost.subvencao_estadual": function(newValue, oldValue) {
      if (
        !newValue ||
        newValue == oldValue ||
        newValue?.subvencao_estadual == oldValue?.subvencao_estadual
      )
        return this.CalcularPrecoSegurado();
    },
    "newCost.subvencao_federal": function(newValue, oldValue) {
      if (
        !newValue ||
        newValue == oldValue ||
        newValue?.subvencao_federal == oldValue?.subvencao_federal
      )
        return this.CalcularPrecoSegurado();
    },
    "newCost.premio_total": function(newValue, oldValue) {
      if (
        !newValue ||
        newValue == oldValue ||
        newValue?.premio_total == oldValue?.premio_total
      )
        return this.CalcularPrecoSegurado();
    },
    valorCoverageSelected(newVal, oldVal) {
      if (oldVal != 0 || newVal != oldVal) this.selectedCoverageValor();
    }
  },
  props: {
    value: {
      type: Object
    },
    optionsQuotation: {
      type: Object
    },
    itemIndex: {
      type: Number
    }
  }
};
</script>
<style lang="sass">
.containerAddCost
  max-width: 100% !important
  margin: 0 auto !important
  padding: 0 auto !important
.iconTooltipPos
  margin-bottom: -41px
  margin-left: 40px
.iconTooltipLmi
  margin-bottom: -41px
  margin-left: 180px
.colPos
  margin-top: -21px
</style>
